import { ReportActions } from '@/modules/reports/store/actions';
import { ReportGetters } from '@/modules/reports/store/getters';
import { ReportMutations } from '@/modules/reports/store/mutations';
import { ReportState, IReportState } from '@/modules/reports/store/state';
import { IRootState } from '@/store/state';
import { Module } from 'vuex';

export const ReportStore: IReportStore = {
  state: ReportState,
  actions: ReportActions,
  getters: ReportGetters,
  mutations: ReportMutations
};

/**
 * --------------------------------------------------
 *	Reports Store Interface
 * --------------------------------------------------
 **/
export interface IReportStore extends Module<IReportState, IRootState> {}
